/* mp-store.js — reveal, gallery dots, pack + plan selection, sticky bar.
   Guarded against double init (every section references this file). */
(function(){
  if (window.__mpStore) return; window.__mpStore = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(){
    var els = document.querySelectorAll('.mp-reveal:not([data-in])');
    if (!('IntersectionObserver' in window) || reduce){
      els.forEach(function(e){ e.setAttribute('data-in',''); }); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ en.target.setAttribute('data-in',''); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    els.forEach(function(e){ io.observe(e); });
  }

  function money(cents, format){
    var v = (cents/100).toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function pdp(root){
    var form = root.querySelector('[data-mp-form]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var priceEls = root.querySelectorAll('[data-mp-price]');
    var qtyInput = root.querySelector('[data-mp-qty]');
    var totalEl = root.querySelector('[data-mp-total]');
    var stickyLabel = root.querySelector('[data-mp-sticky-label]');
    var unitEl = root.querySelector('[data-mp-unit]');
    var submits = root.querySelectorAll('[data-mp-submit]');
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';

    function state(){
      var pack = root.querySelector('.mp-pack[aria-checked="true"]');
      var plan = root.querySelector('.mp-plan[aria-checked="true"]');
      if (!pack) return;
      var price = parseInt(pack.dataset.price || '0', 10);
      var pct = plan && plan.dataset.discount ? parseFloat(plan.dataset.discount) : 0;
      var final = Math.round(price * (1 - pct/100));
      if (idInput) idInput.value = pack.dataset.variantId || '';
      if (planInput) planInput.value = (plan && plan.dataset.planId) || '';
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      var maxq = qtyInput ? (parseInt(qtyInput.max, 10) || 99) : 99;
      if (qty > maxq) { qty = maxq; if (qtyInput) qtyInput.value = maxq; }
      priceEls.forEach(function(el){ el.textContent = money(final * qty, fmt); });
      if (totalEl) totalEl.textContent = money(final * qty, fmt);
      // Per-cake price. Count comes from the variant metafield custom.units if
      // set, otherwise the first number in the pack label ("6 cakes" -> 6).
      var count = parseInt(pack.dataset.count, 10);
      if (!count) {
        var nm = pack.querySelector('.mp-pack__n');
        var m = nm && nm.textContent.match(/\d+/);
        count = m ? parseInt(m[0], 10) : 0;
      }
      var single = pack.parentElement && pack.parentElement.hasAttribute('data-single');
      if (unitEl && single) {
        unitEl.textContent = money(final, fmt) + ' / cake';
      } else if (unitEl) {
        unitEl.textContent = count > 1 ? money(Math.round(final / count), fmt) + ' / cake' : '';
      }
      if (stickyLabel) {
        var pn = pack.querySelector('.mp-pack__n');
        stickyLabel.textContent = single ? (qty + (qty > 1 ? ' cakes' : ' cake')) : (pn ? pn.textContent : '') + (qty > 1 ? ' × ' + qty : '');
      }
      var avail = pack.dataset.available !== 'false';
      submits.forEach(function(b){
        b.disabled = !avail;
        var lab = b.querySelector('[data-mp-label]');
        if (lab && b.dataset.labelSold) lab.textContent = avail ? (b.dataset.label || lab.textContent) : b.dataset.labelSold;
      });
    }

    function group(sel){
      root.querySelectorAll(sel).forEach(function(btn){
        btn.addEventListener('click', function(){
          root.querySelectorAll(sel).forEach(function(o){ o.setAttribute('aria-checked','false'); });
          btn.setAttribute('aria-checked','true');
          state();
        });
      });
    }
    group('.mp-pack'); group('.mp-plan');
    if (qtyInput) qtyInput.addEventListener('input', state);
    state();

    // gallery dots
    var media = root.querySelector('.mp-pdp__media');
    var dots = root.querySelector('.mp-pdp__dots');
    if (media && dots){
      media.addEventListener('scroll', function(){
        var i = Math.round(media.scrollLeft / (media.scrollWidth / media.children.length));
        Array.prototype.forEach.call(dots.children, function(d, n){
          if (n === i) d.setAttribute('data-on',''); else d.removeAttribute('data-on');
        });
      }, { passive: true });
    }

    // sticky bar appears once the inline buy panel scrolls away
    var sticky = root.querySelector('.mp-sticky');
    var anchor = root.querySelector('[data-mp-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window){
      new IntersectionObserver(function(e){
        if (e[0].isIntersecting) sticky.removeAttribute('data-show');
        else sticky.setAttribute('data-show','');
      }, { threshold: 0 }).observe(anchor);
      sticky.querySelector('[data-mp-sticky-submit]') && sticky.querySelector('[data-mp-sticky-submit]').addEventListener('click', function(){
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  // reservation (pre-order) form: when the Restrict setting is on, block submit
  // for ZIPs outside the delivery area (90001–96162), and swallow honeypot hits. Field is never
  // disabled — with JS off the form still posts and the server takes it.
  function reservation(){
    document.querySelectorAll('form[data-mp-reservation]').forEach(function(form){
      if (form.__mpReserve) return; form.__mpReserve = true;
      var zip = form.querySelector('[name="contact[zip]"]');
      var msg = form.querySelector('[data-mp-reserve-zip-msg]');
      var hp = form.querySelector('[name="contact[nickname]"]');
      var submit = form.querySelector('[data-mp-reserve-submit]');

      var restrict = form.getAttribute('data-mp-restrict-ca') === 'true';
      function zipInCA(){
        var val = (zip && zip.value || '').trim();
        if (!/^\d{5}$/.test(val)) return false;
        var n = parseInt(val, 10);
        return n >= 90001 && n <= 96162;
      }
      function zipOk(){ return restrict ? zipInCA() : /^\d{5}$/.test((zip && zip.value || '').trim()); }
      if (zip) zip.addEventListener('input', function(){
        if (msg) msg.hidden = true;
        zip.removeAttribute('aria-invalid');
      });

      form.addEventListener('submit', function(e){
        if (hp && hp.value){ e.preventDefault(); return; }
        if (!zipOk()){
          e.preventDefault();
          if (msg) msg.hidden = false;
          if (zip){ zip.setAttribute('aria-invalid', 'true'); zip.focus(); }
          return;
        }
        if (submit) submit.setAttribute('aria-busy', 'true');
      });
    });
  }

  // reservation pack-size picker — pick a size, pick a quantity, see a live
  // total; keeps hidden contact[pack]/unit_price/qty/total fields in sync so
  // the email always carries the real numbers instead of just the cheapest
  // variant's price.
  function reservePack(){
    document.querySelectorAll('.mp-reserve[data-money-format]').forEach(function(root){
      if (root.__mpReservePack) return; root.__mpReservePack = true;
      var fmt = root.getAttribute('data-money-format') || '${{amount}}';
      var packs = root.querySelectorAll('.mp-pack');
      var qtyInput = root.querySelector('[data-mp-reserve-qty]');
      var totalEl = root.querySelector('[data-mp-reserve-total]');
      var perCakeEl = root.querySelector('[data-mp-reserve-unit]');
      var packField = root.querySelector('[data-mp-reserve-pack]');
      var unitField = root.querySelector('[data-mp-reserve-unit-price]');
      var qtyField = root.querySelector('[data-mp-reserve-qty-field]');
      var totalField = root.querySelector('[data-mp-reserve-total-field]');

      function selected(){
        return root.querySelector('.mp-pack[aria-checked="true"]') || packs[0];
      }
      function recompute(){
        var pack = selected();
        if (!pack) return;
        var price = parseInt(pack.dataset.price || '0', 10);
        var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
        var total = price * qty;
        var count = parseInt(pack.dataset.title || '0', 10);
        if (totalEl) totalEl.textContent = money(total, fmt);
        if (perCakeEl) perCakeEl.textContent = count > 1 ? money(Math.round(price / count), fmt) + ' / cake' : '';
        if (packField) packField.value = pack.dataset.title + ' cake' + (pack.dataset.title === '1' ? '' : 's');
        if (unitField) unitField.value = money(price, fmt);
        if (qtyField) qtyField.value = qty;
        if (totalField) totalField.value = money(total, fmt);
      }

      packs.forEach(function(btn){
        btn.addEventListener('click', function(){
          packs.forEach(function(o){ o.setAttribute('aria-checked', 'false'); });
          btn.setAttribute('aria-checked', 'true');
          recompute();
        });
      });
      if (qtyInput) qtyInput.addEventListener('input', recompute);
      recompute();
    });
  }

  // mobile header menu: the toggle opens the nav as a dropdown panel.
  // Desktop CSS keeps the nav inline and hides the toggle, so this is inert there.
  function menu(){
    document.querySelectorAll('.mp-header__toggle').forEach(function(toggle){
      if (toggle.__mpMenu) return; toggle.__mpMenu = true;
      var nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!nav) return;
      function set(open){
        if (open) nav.setAttribute('data-open', ''); else nav.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      toggle.addEventListener('click', function(){ set(!nav.hasAttribute('data-open')); });
      nav.addEventListener('click', function(e){ if (e.target.closest('a')) set(false); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') set(false); });
      document.addEventListener('click', function(e){
        if (nav.hasAttribute('data-open') && !nav.contains(e.target) && !toggle.contains(e.target)) set(false);
      });
    });
  }

  // proof — video panels. Play only while on screen; a button turns sound on.
  function proof(){
    document.querySelectorAll('.mp-proof__panel').forEach(function(panel){
      if (panel.__mpProof) return; panel.__mpProof = true;
      var video = panel.querySelector('video');
      if (!video) return;

      if (reduce) { video.removeAttribute('autoplay'); video.pause(); return; }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if (en.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function(){}); }
            else video.pause();
          });
        }, { threshold: 0.25 }).observe(panel);
      }

      var btn = panel.querySelector('[data-mp-sound]');
      if (btn) btn.addEventListener('click', function(){
        video.muted = !video.muted;
        video.controls = !video.muted;
        if (video.muted) panel.removeAttribute('data-sound-on');
        else { panel.setAttribute('data-sound-on', ''); var p = video.play(); if (p && p.catch) p.catch(function(){}); }
      });
    });
  }

  // reviews — the form posts through the native contact form (same mechanism
  // as Contact/Wholesale/Reservation), which redirects back to the same page
  // on its own, so no fetch/redirect workaround is needed here. This just
  // re-opens the collapsed disclosure after a round trip that came back with
  // an error or the success note.
  function reviews(){
    document.querySelectorAll('[data-mp-review-disclosure]').forEach(function(d){
      if (!d.open && d.querySelector('.mp-form-err, .mp-reserve__ok')) d.open = true;
    });
  }

  // generic honeypot: any contact form carrying a contact[nickname] field is
  // blocked from submitting if that field has a value (bots fill every input).
  function honeypot(){
    document.querySelectorAll('input[name="contact[nickname]"]').forEach(function(hp){
      var form = hp.form;
      if (!form || form.__mpHp) return; form.__mpHp = true;
      form.addEventListener('submit', function(e){ if (hp.value) e.preventDefault(); });
    });
  }

  // "Also for" toggle on MP Who — reveals blocks 3+ in place, no navigation.
  function whoToggle(){
    document.querySelectorAll('[data-mp-who-toggle]').forEach(function(btn){
      if (btn.__mpWhoToggle) return; btn.__mpWhoToggle = true;
      var scope = btn.closest('.mp-who-sec') || document;
      var extras = scope.querySelectorAll('[data-mp-who-extra]');
      var label = btn.querySelector('.mp-who__toggle-label');
      var closed = btn.getAttribute('data-label-closed');
      var open = btn.getAttribute('data-label-open');
      btn.addEventListener('click', function(){
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        extras.forEach(function(el){ el.hidden = isOpen; });
        if (label) label.textContent = isOpen ? closed : open;
      });
    });
  }

  function init(){
    reveal();
    menu();
    proof();
    reviews();
    honeypot();
    whoToggle();
    document.querySelectorAll('[data-mp-pdp]').forEach(pdp);
    reservation();
    reservePack();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
